import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import {ClientApp} from './components/App/ClientApp';
import './index.less';

// Main entrypoint that webpack uses to bundle the client-side code.
// See the "App" component directory for graphql setup and client side routes (react-router)
ReactDOM.hydrate(<ClientApp />, document.getElementById('root'));
